import request from './request';

export default {
	async login(email, password) {
		const response = await request.post('/app/auth/login', {
			email,
			password
		});
		return response;
	},
	async getWebCasUrl(query) {
		const res = await request.get('/app/auth/web-cas/url', query);
		return res;
	},
	async webCasAuth(body) {
		const res = await request.post('/app/auth/web-cas/auth', body);
		return res;
	},
	async logout() {
		const res = await request.post('/app/auth/logout');
		return res;
	}
};
